import React from "react";

import Navigation from "./header/Navigation";
import AnnouncementBar from "./basic/AnnouncementBar";
import Footer from "./footer/footer";

export default ({ darkMode, children, className }) => (
	<div className={`layout-wrapper ${className}`} >
		<AnnouncementBar />
		<Navigation className="layout__navigation" darkMode={darkMode} />
		{children}
		<Footer className="layout__footer" />
	</div>
);
